import { Controller } from 'stimulus';

export default class extends Controller {
  public clickRemoveButton(event: Event) {
    event.preventDefault();
    $('#election_vote_box_id').val('');
  }
}
